/* tutor-2 (C.3, C.4, C.5, D.2): EL BOTON "TUTOR" DE LAS CABECERAS: chip naranja suave de 36 de alto con la chispa y
   la palabra (`tutor.mid.button`). Con `soloChispa` (los telefonos angostos donde la palabra no cabe en el renglon de
   la cabecera) queda la chispa sola, 36 x 36 con 44 de toque, y la palabra como `aria-label` y `title`.

   ARCHIVO EN ASCII A PROPOSITO. `apagado` lo pinta igual pero sin tocar (el esqueleto de Adaptive, para que nada
   brinque al cargar). Quien lo monta decide si se pinta: SOLO con `tutorVisible(...)`. */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { AreaDe44 } from '../panel/anatomia';
import { useMedia } from '../../lib/useEsAncho';

/** `soloChispaAbajoDe`: el ancho de ventana (px) desde el que la palabra SI cabe en esa cabecera (medido en Chrome en
 *  320, 375, 393 y 440, ES y EN); abajo de el, la chispa sola. Sin el, siempre con la palabra. */
export default function BotonTutor({
  alTocar, soloChispa: forzada = false, soloChispaAbajoDe = 0, apagado = false, testid = 'tutor-boton', abierto,
}) {
  const { t } = useTranslation('study');
  const angosto = useMedia(`(max-width: ${Math.max(0, soloChispaAbajoDe - 1)}px)`, false);
  const soloChispa = forzada || (soloChispaAbajoDe > 0 && angosto);
  const palabra = t('study:tutor.mid.button');
  return (
    <button type="button" onClick={alTocar} disabled={apagado} aria-label={palabra} title={soloChispa ? palabra : undefined}
      aria-expanded={abierto === undefined ? undefined : Boolean(abierto)}
      className={`relative shrink-0 inline-flex items-center justify-center gap-1.5 h-9 rounded-full bg-[#241710] border border-[#3A2414] text-[#F7A06A] text-[13px] font-semibold whitespace-nowrap disabled:opacity-45 ${soloChispa ? 'w-9' : 'px-3'}`}
      data-testid={testid} data-solo-chispa={soloChispa ? 'true' : 'false'}>
      <AreaDe44 />
      <Sparkles className="w-4 h-4 shrink-0" aria-hidden="true" />
      {soloChispa ? null : <span>{palabra}</span>}
    </button>
  );
}
